import React, { useState, useEffect } from "react";
import { useAsyncAxios, utilAxiosWithAuth } from "../utils/customAxios";
import { Button, Space } from "antd";

import * as Request from "../commons/request";
import * as Types from "../commons/typeDTO";
import * as Utils from "../utils/utils";

import styles from "./RentImageList.module.css";
import IconPlus from "../assets/images/icon_plus.png";
import ImagePreviewer from "./ImagePreviewer";

export type RentImageType2 = {
    rentImages: File[];
};

export type RentImageSubType2 = {
    file?: File;
};

function RentImageList2({
    rentInputImages,
    inputType,
    resetImage,
    onImageListChanged,
    onDeleteImage,
}: {
    rentInputImages?: Types.RentImageDto[];
    inputType?: boolean;
    resetImage?: any;
    onImageListChanged?: (imageList: RentImageSubType2[]) => void;
    onDeleteImage?: (rentImageId: number) => void;
}) {
    const [rentImages, setRentImages] = useState<Array<RentImageSubType2>>([]);

    useEffect(() => {
        setRentImages([]);
    }, [rentInputImages?.length]);

    return (
        <div>
            {rentInputImages && rentInputImages.length > 0 && (
                <div>
                    {rentInputImages.map((image) => (
                        <ImagePreviewer
                            key={image.filePath}
                            title="추가 사진"
                            value={image}
                            enableAdd={rentInputImages?.length === 0}
                            disabled={!inputType}
                            resetImage={resetImage}
                            onImageChanged={(file, imageSrc, isDelete, imageId) => {
                                if (isDelete && imageId) onDeleteImage && onDeleteImage(imageId);
                            }}
                        />
                    ))}
                </div>
            )}
            {rentImages.length > 0 && (
                <div>
                    {rentImages.map((rentImage, index) => (
                        <ImagePreviewer
                            key={index}
                            title="추가 사진"
                            disabled={!inputType}
                            enableAdd={rentInputImages?.length === 0}
                            resetImage={resetImage}
                            onImageChanged={(file, imageSrc, isDelete, imageId) => {
                                console.log(file, isDelete, imageId);
                                if (isDelete === false) rentImage.file = file;
                                else rentImage.file = undefined;

                                if (isDelete && imageId) onDeleteImage && onDeleteImage(imageId);

                                if (onImageListChanged !== undefined) {
                                    onImageListChanged(rentImages);
                                }
                            }}
                        />
                    ))}
                </div>
            )}
            {inputType && rentInputImages?.length === 0 && (
                <div style={{ marginLeft: rentImages.length > 0 ? "16px" : "0px" }}>
                    <div className={`${styles.bgEmpty}`} onClick={() => setRentImages([...rentImages, { file: undefined }])}>
                        <img src={IconPlus} width={30} />
                        <p className="b-lg mt-2" style={{ color: "#1C2E4599" }}>
                            추가
                        </p>
                    </div>
                    {/* <p className="mt-1">&nbsp;</p> */}
                </div>
            )}
        </div>
    );
}

export default RentImageList2;
